import { addMonths } from "date-fns";

export const anredeArray = [
  { id: "01", value: "Herr", label: "Herr" },
  { id: "02", value: "Frau", label: "Frau" },
];

export const anredeWithBlankArray = [
  { id: "00", value: " ", label: " " },
  { id: "01", value: "Herr", label: "Herr" },
  { id: "02", value: "Frau", label: "Frau" },
];

export const eventTypeArray = [
  { id: "01", value: "testing", label: "Prüfung" },
  { id: "02", value: "tournament", label: "Turnier" },
  { id: "03", value: "course", label: "Lehrgang" },
  { id: "04", value: "camp", label: "Camp" },
];

export const laufzeitArray = [
  { id: "01", value: 1, label: "1 Monat" },
  { id: "02", value: 2, label: "2 Monate" },
  { id: "03", value: 3, label: "3 Monate" },
  { id: "04", value: 4, label: "4 Monate" },
  { id: "05", value: 5, label: "5 Monate" },
  { id: "06", value: 6, label: "6 Monate" },
  { id: "07", value: 7, label: "7 Monate" },
  { id: "08", value: 8, label: "8 Monate" },
  { id: "09", value: 9, label: "9 Monate" },
  { id: "10", value: 10, label: "10 Monate" },
  { id: "11", value: 11, label: "11 Monate" },
  { id: "12", value: 12, label: "12 Monate" },
];

export const bezahltBisArray = Array.from({ length: 12 }, (item, index) => {
  let indexDate = addMonths(new Date(), index - 5);
  let y = indexDate.getFullYear();
  let mm = indexDate.getMonth() + 1;
  mm = ("0000" + mm).slice(-2);
  return {
    id: index + 1,
    value: `${mm}/${y}`,
    label: `${mm}/${y}`,
  };
});

export const getNewMemberPayedTillValue = () => {
  let date = new Date();
  let y = date.getFullYear();
  let mm = date.getMonth() + 1;
  mm = ("0000" + mm).slice(-2);
  return `${mm}/${y}`;
};

export const getCurrentMonthPayedTillValue = () => {
  let date = addMonths(new Date(), 1);
  let y = date.getFullYear();
  let mm = date.getMonth() + 1;
  mm = ("0000" + mm).slice(-2);
  return `${mm}/${y}`;
};

export const getDateFromPayedTillString = (payedTill) => {
  let dateArray = payedTill.split("/").reverse();
  dateArray = dateArray.map((x) => parseInt(x));
  dateArray[1] -= 1;
  let payedTillDate = new Date(...dateArray, 1);
  return payedTillDate;
};

export const getStringFromPayedTillDate = (date) => {
  let y = date.getFullYear();
  let mm = date.getMonth() + 1;
  mm = ("0000" + mm).slice(-2);
  return `${mm}/${y}`;
};

export const gradArray = [
  { id: 1, value: 0, label: "10. Kup" },
  { id: 2, value: 1, label: "9. Kup" },
  { id: 3, value: 2, label: "8. Kup" },
  { id: 4, value: 3, label: "7. Kup" },
  { id: 5, value: 4, label: "6. Kup" },
  { id: 6, value: 5, label: "5. Kup" },
  { id: 7, value: 6, label: "4. Kup" },
  { id: 8, value: 7, label: "3. Kup" },
  { id: 9, value: 8, label: "2. Kup" },
  { id: 10, value: 9, label: "1. Kup" },
  { id: 11, value: 10, label: "POOM" },
  { id: 12, value: 11, label: "1. Dan" },
  { id: 13, value: 12, label: "2. Dan" },
  { id: 14, value: 13, label: "3. Dan" },
  { id: 15, value: 14, label: "4. Dan" },
  { id: 16, value: 15, label: "5. Dan" },
  { id: 17, value: 16, label: "6. Dan" },
];

export const statusArray = [
  { id: 1, value: "active", label: "AKTIV" },
  { id: 2, value: "frozen", label: "EINGEFROREN" },
  { id: 3, value: "terminated", label: "GEKÜNDIGT" },
  { id: 4, value: "pending", label: "WARTEND" },
  { id: 5, value: "rejected", label: "ABGELEHNT" },
];

export const fullMemberFormData = [
  // DO NOT CHANGE! ORDER IS USED FOR DISPLAYING DATA
  {
    type: "select",
    selectList: anredeArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Anrede",
    value: "title",
    required: true,
    errorMsg: "Bitte eine Anrede auswählen.",
  },
  {
    type: "text",
    label: "Nachname",
    value: "lastName",
    required: true,
    errorMsg: "Bitte den Nachnamen eingeben.",
  },
  {
    type: "text",
    label: "Vorname",
    value: "firstName",
    required: true,
    errorMsg: "Bitte den Vornamen eingeben.",
  },
  {
    type: "date",
    label: "Geburtstag",
    value: "birthdate",
    required: false,
    errorMsg: "Bitte das Geburtsdatum eingeben.",
  },
  {
    type: "text",
    label: "Mitgliedsnummer",
    value: "memberNumber",
    // disabled: true,
    required: true,
  },
  {
    type: "number",
    label: "Mitgliedsbeitrag in Euro",
    value: "contribution",
    required: true,
  },
  {
    type: "date",
    label: "Vertragsdatum",
    value: "contractDate",
    required: true,
    errorMsg: "Bitte das Vertragsdatum eingeben.",
  },
  {
    type: "number",
    label: "Vertragslaufzeit in Monaten",
    value: "contractDuration",
    required: true,
    errorMsg: "Bitte die Vertragslaufzeit auswählen.",
    endAdornment: "Monate",
  },
  {
    type: "number",
    label: "Vertragsverlängerung in Monaten",
    value: "contractExtension",
    required: false,
    errorMsg: "Bitte die Dauer der Vertragsverlängerung auswählen.",
    endAdornment: "Monate",
  },
  {
    type: "number",
    fieldWidth: 2,
    label: "Kündigungsfrist in Monaten",
    value: "noticePeriod",
    required: true,
    errorMsg: "Bitte die Kündigungsfrist eingeben.",
    endAdornment: "Monate",
  },
  {
    type: "number",
    label: "Anmeldegebühr in Euro",
    value: "registrationFee",
    required: false,
    helperText: "Wird nur eingezogen wenn Haken gesetzt ist",
  },
  {
    type: "select",
    fieldWidth: 2,
    selectList: gradArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Gürtelgrad",
    value: "degree",
    required: true,
    errorMsg: "Bitte einen Gürtelgrad auswählen.",
    size: 3,
  },
  {
    type: "date",
    label: "Aktiv seit",
    value: "beginningDate",
    required: false,
    size: 4,
  },
  {
    type: "date",
    label: "Letzte Prüfung",
    value: "lastTesting",
    required: false,
    size: 4,
  },
  {
    type: "text",
    label: "Kommentar",
    value: "comment",
    multiline: true,
    required: false,
    size: 12,
  },
];

export const affiliatedMemberFields = [
  {
    type: "select",
    selectList: anredeArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Anrede",
    value: "title",
    required: true,
    errorMsg: "Bitte eine Anrede auswählen.",
  },
  {
    type: "text",
    label: "Nachname",
    value: "lastName",
    required: true,
    errorMsg: "Bitte den Nachnamen eingeben.",
  },
  {
    type: "text",
    label: "Vorname",
    value: "firstName",
    required: true,
    errorMsg: "Bitte den Vornamen eingeben.",
  },
  {
    type: "date",
    label: "Geburtstag",
    value: "birthdate",
    required: false,
    errorMsg: "Bitte das Geburtsdatum eingeben.",
  },
  {
    type: "select",
    selectList: gradArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Gürtelgrad",
    value: "degree",
    required: true,
    errorMsg: "Bitte einen Gürtelgrad auswählen.",
  },
  {
    type: "date",
    label: "Aktiv seit",
    value: "beginningDate",
    required: false,
  },
];

export const bankData = [
  {
    type: "text",
    label: "Straße, Hausnummer",
    value: "street",
    required: false,
  },
  {
    type: "text",
    label: "PLZ",
    value: "zip",
    required: false,
  },
  {
    type: "text",
    label: "Ort",
    value: "city",
    required: false,
  },
  {
    type: "text",
    label: "Telefon",
    value: "phoneNumber",
    required: false,
  },
  {
    type: "text",
    label: "Mobil",
    value: "mobile",
    required: false,
  },
  {
    type: "text",
    label: "E-Mail",
    value: "email",
    required: false,
  },
  {
    type: "autoInput",
    label: "Inhaber",
    value: "owner",
    required: true,
    errorMsg: "Bitte den Kontoinhaber angeben",
  },
  {
    type: "text",
    label: "Kreditinstitut",
    value: "bank",
    required: false,
  },
  {
    type: "text",
    label: "IBAN",
    value: "iban",
    required: false,
  },
  {
    type: "text",
    label: "BIC",
    value: "bic",
    required: false,
  },
];

export const standortLeiterFormData = [
  {
    type: "select",
    selectList: anredeArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Anrede",
    value: "title",
    required: true,
    errorMsg: "Bitte eine Anrede auswählen.",
  },
  {
    type: "text",
    label: "Nachname",
    value: "lastName",
    required: true,
    errorMsg: "Bitte den Nachnamen eingeben.",
  },
  {
    type: "text",
    label: "Vorname",
    value: "firstName",
    required: true,
    errorMsg: "Bitte den Vornamen eingeben.",
  },
  {
    type: "date",
    label: "Geburtstag",
    value: "birthdate",
    required: false,
    errorMsg: "Bitte das Geburtsdatum eingeben.",
  },
  {
    type: "select",
    selectList: gradArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Gürtelgrad",
    value: "degree",
    required: false,
  },
  {
    type: "text",
    label: "Mitgliedsnummer",
    value: "memberNumber",
    disabled: false,
    required: false,
  },
  {
    type: "date",
    label: "Aktiv seit",
    value: "contractDate",
    required: false,
  },
  {
    type: "text",
    label: "Mitgliedsbeitrag in Euro",
    value: "contribution",
    required: false,
  },
  {
    type: "text",
    label: "E-Mail",
    value: "email",
    required: false,
  },
  {
    type: "text",
    label: "Telefon",
    value: "phoneNumber",
    required: false,
  },
  {
    type: "text",
    label: "Mobil",
    value: "mobile",
    required: false,
  },
  {
    type: "text",
    label: "Straße, Hausnummer",
    value: "street",
    required: false,
  },
  {
    type: "text",
    label: "PLZ",
    value: "zip",
    required: false,
  },
  {
    type: "text",
    label: "Ort",
    value: "city",
    required: false,
  },
];

export const eventFormData = [
  {
    type: "select",
    selectList: eventTypeArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Art der Veranstaltung",
    value: "eventType",
    required: true,
    errorMsg: "Bitte eine Veranstaltungsart auswählen.",
  },
  {
    type: "text",
    label: "Name der Veranstaltung",
    value: "eventName",
    required: true,
    errorMsg: "Bitte den Namen der Veranstaltung eingeben.",
  },
  {
    type: "date",
    label: "Beginn",
    value: "eventDateBegin",
    required: false,
  },
  {
    type: "date",
    label: "Ende",
    value: "eventDateEnd",
    required: false,
  },
  {
    type: "text",
    label: "Straße, Hausnummer",
    value: "street",
    required: false,
  },
  {
    type: "text",
    label: "PLZ",
    value: "zip",
    required: false,
  },
  {
    type: "text",
    label: "Ort",
    value: "city",
    required: false,
  },
];

export const defaultSiteFormValues = {
  siteName: "",
  memberIdentifier: "",
  latestMemberNumber: "1",
  contractDuration: "6",
  contractExtension: "1",
  noticePeriod: "1",
  memberContribution: "50",
  enrollmentFee: "",
  publicRegistrationOptions: [],
  publicRegistrationDocuments: [],
  publicRegistrationDiscounts: [],
  trainingSessions: [],
  openingHours: [],
  visibleForMembers: true,
  publicInfoText: "",
  siteOwner: "",
  trainer1: "",
  trainer2: "",
  street: "",
  zip: "",
  city: "",
  email: "",
  phone: "",
};

export const standortFormData = [
  {
    type: "text",
    label: "Standortname",
    value: "siteName",
    required: true,
    helperText: "Eindeutiger Standortname",
    errorMsg: "Bitte den Namen des Standorts eingeben.",
  },
  {
    type: "text",
    label: "Standortkennzeichnung",
    value: "memberIdentifier",
    placeholder: "Kürzel für Mitgliedsnummern eingeben",
    helperText: "Zum Beispiel: M für München, A für Augsburg...",
    showHelperText: true,
    required: true,
    errorMsg: "Bitte angeben.",
  },
  {
    type: "number",
    label: "Nächste Mitgliedsnummer (Nur Zahl)",
    value: "latestMemberNumber",
    helperText: "Hier können Sie die Nummer für das nächste Mitglied ändern",
    showHelperText: true,
    required: false,
  },
  {
    type: "number",
    selectList: laufzeitArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Vertragslaufzeit in Monaten",
    helperText: "Monate",
    value: "contractDuration",
    required: false,
    errorMsg: "Bitte die Vertragslaufzeit auswählen.",
  },
  {
    type: "number",
    label: "Vertragsverlängerung in Monaten",
    value: "contractExtension",
    helperText: "Monate",
    required: false,
    errorMsg: "Bitte die Dauer der Vertragsverlängerung auswählen.",
  },
  {
    type: "number",
    selectList: laufzeitArray, // [{id: Number for Key, value: value for database, label: label for user}]
    label: "Kündigungsfrist in Monaten",
    helperText: "Monate",
    value: "noticePeriod",
    required: false,
    errorMsg: "Bitte die Kündigungsfrist auswählen.",
  },
  {
    type: "number",
    label: "Mitgliedsbeitrag in €",
    value: "memberContribution",
    required: false,
    helperText: "Nur die Zahl eingeben. Zum Beispiel: 70,00",
    showHelperText: true,
  },
  {
    type: "number",
    label: "Aufnahme- / Vereinsgebühr in €",
    value: "enrollmentFee",
    required: false,
    helperText: "Nur die Zahl eingeben. Zum Beispiel: 70,00",
    showHelperText: true,
  },
  {
    type: "text",
    label: "Leitung",
    value: "siteOwner",
    required: false,
  },
  {
    type: "text",
    label: "Trainer 1",
    value: "trainer1",
    required: false,
  },
  {
    type: "text",
    label: "Trainer 2",
    value: "trainer2",
    required: false,
  },
  {
    type: "text",
    label: "Straße, Hausnummer",
    value: "street",
    required: false,
  },
  {
    type: "text",
    label: "PLZ",
    value: "zip",
    required: false,
  },
  {
    type: "text",
    label: "Ort",
    value: "city",
    required: false,
  },
  {
    type: "text",
    label: "E-Mail",
    value: "email",
    required: false,
  },
  {
    type: "text",
    label: "Rufnummer",
    value: "phone",
    required: false,
  },
];

export const mapValuesToFieldLabels = (dataObject, fieldArray) => {
  let mappedFields = [];

  for (const [key, value] of Object.entries(dataObject)) {
    fieldArray.forEach((field) => {
      if (key === field.value && value !== "") {
        mappedFields.push({ label: field.label, value: value, key: key });
      }
      return;
    });
  }
  return mappedFields;
};

export const parentDataFields = [
  {
    type: "text",
    label: "Nachname",
    value: "lastName",
    required: true,
    errorMsg: "Bitte den Nachnamen eingeben.",
    minHeight: true,
  },
  {
    type: "text",
    label: "Vorname",
    value: "firstName",
    required: true,
    errorMsg: "Bitte den Vornamen eingeben.",
    minHeight: true,
  },
  {
    type: "date",
    label: "Geburtstag",
    value: "birthdate",
    required: false,
    errorMsg: "Bitte das Geburtsdatum eingeben.",
    minHeight: true,
  },
];

export const contactDataFields = [
  {
    type: "text",
    label: "Straße, Hausnummer",
    value: "street",
    required: false,
  },
  {
    type: "text",
    label: "PLZ",
    value: "zip",
    required: false,
  },
  {
    type: "text",
    label: "Ort",
    value: "city",
    required: false,
  },
  {
    type: "text",
    label: "Telefon",
    value: "phoneNumber",
    required: false,
  },
  {
    type: "text",
    label: "Mobil",
    value: "mobile",
    required: false,
  },
  {
    type: "text",
    label: "E-Mail",
    value: "email",
    required: "Bitte eine gültige E-Mail eingeben.",
    errorMsg: "Bitte eine gültige E-Mail eingeben.",
  },
];

export const bankDataOwnerField = {
  type: "owner",
  label: "Inhaber",
  value: "owner",
  required: false,
  size: 3,
};

export const bankDataFields = [
  {
    type: "text",
    label: "Kreditinstitut",
    value: "bank",
    required: false,
    size: 3,
    minHeight: true,
  },
  {
    type: "text",
    label: "IBAN",
    value: "iban",
    required: "Bitte eine IBAN eingeben.",
    size: 3,
    minHeight: true,
  },
  {
    type: "text",
    label: "BIC",
    value: "bic",
    required: false,
    size: 3,
    minHeight: true,
  },
];
